import React from 'react';
import { FieldError, FieldLabel, Field } from '@/components/ui/field';
import { cn } from '@/lib/utils';

interface FormFieldProps {
  label?: string;
  name: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const FormField = ({ label, name, error, required = false, children, className }: FormFieldProps) => {
  return (
    <Field className={cn(className, 'relative mt-auto')} data-invalid={!!error}>
      {label && (
        <FieldLabel htmlFor={name} className="inline truncate max-w-full">
          {label} {required && <span className="text-destructive">*</span>}
        </FieldLabel>
      )}
      {children}
      <FieldError className="absolute top-full pt-2 text-xs">{error}</FieldError>
    </Field>
  );
};
